import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import { getPayRequest, approvePayRequest, getPayRequestOne } from "@/api/payItem";
import { getPayMap, getUserInfoMap, getGameServerMap } from "@/utils/dictionary";
import infoList from "../../mixins/infoList";
import showRecMsg from "./components/showRecMsg.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  components: {
    showRecMsg: showRecMsg,
    DataOptions: DataOptions
  },
  name: "payApproval",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getPayRequest,
      approveID: "",
      request_id: "",
      serverMap: {},
      UserInfoList: {},
      PayInfoList: {},
      roleList: [],
      payItemList: [],
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      isShow: false,
      approve_state: 0,
      itemStatus: {
        1: "待审批",
        2: "审批驳回",
        3: "审批通过"
      },
      options: [{
        id: 0,
        label: "全部"
      }, {
        id: 1,
        label: "待审批"
      }, {
        id: 2,
        label: "审批驳回"
      }, {
        id: 3,
        label: "审批通过"
      }],
      aprClass: {
        1: "notApproved",
        2: "FailApproved",
        3: "Approved"
      },
      //填写审批原因弹出框
      centerDialogVisible: false,
      //查看充值申请详细信息的弹出框
      dialogFormVisible: false,
      textarea1: "",
      //审核是否能通过
      radio: "0",
      nowPayState: 0,
      //判断是修改1还是查看2
      auditType: 0,
      //传给查看的每一行数据
      formData: {},
      searchInfo: {},
      showReason: "",
      multipleSelection: [],
      approveArr: [],
      radioID: "",
      //单项审批为1，多项审批为2
      isRadioType: 1
    };
  },
  created: function created() {
    this.init();
    this.queryEvent();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, res1;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverMap = _context.sent;
              _context.next = 5;
              return getUserInfoMap();
            case 5:
              res = _context.sent;
              _this.UserInfoList = res;
              _context.next = 9;
              return getPayMap();
            case 9:
              res1 = _context.sent;
              _this.PayInfoList = res1;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.formTime[0];
              _this2.searchInfo.edate = _this2.formTime[1];
              _this2.searchInfo.approve_state = _this2.approve_state;
              if (_this2.approve_state == 1) {
                _this2.isShow = true;
              } else {
                _this2.isShow = false;
              }
              _context2.next = 6;
              return _this2.getTableData();
            case 6:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //查看邮件信息
    checkPay: function checkPay(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getPayRequestOne({
                id: row.id
              });
            case 2:
              res = _context3.sent;
              _this3.formData = res.data;
              console.log("this.formData", _this3.formData);
              _this3.dialogFormVisible = true;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleEdit: function handleEdit(row) {
      this.radio = "0";
      this.roleList = row.role_list;
      this.payItemList = row.pay_item_id;
      this.nowPayState = row.approve_state;
      this.showReason = row.approve_reason;
      this.approveID = row.approve_id;
      this.request_id = row.role_list[0].request_id;
      this.auditType = 1;
      this.isRadioType = 1;
      this.radioID = row.id;
      this.centerDialogVisible = true;
    },
    // 1:待审核，2:审核驳回，3:审核通过
    handleCheckReason: function handleCheckReason(row) {
      this.auditType = 2;
      this.roleList = row.role_list;
      this.payItemList = row.pay_item_id;
      this.nowPayState = row.approve_state;
      this.showReason = row.approve_reason;
      this.isRadioType = 1;
      this.radioID = row.id;
      if (row.approve_state === 1) {
        this.radio = "0";
      } else if (row.approve_state === 2) {
        this.radio = "2";
      } else {
        this.radio = "1";
      }
      this.centerDialogVisible = true;
    },
    //新加的多选
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //新加的审批
    approvalBtn: function approvalBtn() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择需要审批项",
          type: "warning"
        });
        return;
      }
      this.approveArr = this.multipleSelection.map(function (item) {
        return item.id;
      });
      this.radio = "0";
      this.nowPayState = 1;
      this.auditType = 1;
      this.isRadioType = 2;
      this.centerDialogVisible = true;
    },
    keepBtn: function keepBtn(e) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var arr, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              arr = [];
              if (e == 1) {
                arr.push(_this4.request_id);
              } else {
                arr = _this4.approveArr;
              }
              _context4.next = 4;
              return approvePayRequest({
                approve_id: 0,
                is_approve: _this4.radio == 1 ? true : false,
                approve_reason: _this4.showReason,
                ids: arr
              });
            case 4:
              res = _context4.sent;
              if (res.code === 0) {
                _this4.$message({
                  message: "恭喜你，邮件审核成功",
                  type: "success"
                });
                _this4.queryEvent();
                _this4.centerDialogVisible = false;
              } else {
                _this4.$message({
                  message: "出错啦",
                  type: "error"
                });
                _this4.centerDialogVisible = false;
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "充值审批功能",
        dangerouslyUseHTMLString: true,
        message: "<div>有权限的用户，可查看所有充值申请信息</div>" + "<div>通过待审批的申请时，需要填写，审批理由，选择申请是否通过</div>" + "<div>审批通过后，调用研发接口，给对应玩家进行对应充值项的充值流程</div>",
        duration: 0
      });
    },
    getItemNameList: function getItemNameList(payItemId) {
      var _this5 = this;
      var ary = [];
      payItemId.split(',').forEach(function (itemId) {
        ary.push("".concat(itemId, " - ").concat(_this5.PayInfoList[itemId] || ''));
      });
      return ary;
    },
    dialogHeadStyle: function dialogHeadStyle() {
      var styleJson = {};
      styleJson = {
        color: "#409EFF"
      };
      return styleJson;
    },
    dialogRowStyle: function dialogRowStyle() {
      var styleJson = {};
      styleJson = {
        color: "#67c23a",
        backgroundColor: "#f0f9eb"
      };
      return styleJson;
    }
  }
};